
import { defineComponent } from 'vue';
import ReadMore from '@/shared/components/ReadMore.vue';
import ResizableImage from '@/shared/components/ResizableImage.vue';

export default defineComponent({
  name: 'AdDeveloperProjectInfo',
  components: {
    ReadMore,
    ResizableImage,
  },
  props: {
    ad: {
      type: Object,
      required: true,
    },
  },
  computed: {
    address(): string {
      let address = '';
      address += this.formatAddressPart(address, '', this.ad.street);
      address += this.formatAddressPart(address, ' ', this.ad.streetNumber);
      address += this.formatAddressPart(address, ', ', this.ad.city);
      return address;
    },
  },
  methods: {
    formatAddressPart(address: string, concatString: string, part: string) {
      if (!address) {
        concatString = '';
      }
      return part ? concatString + part : '';
    },
    onVirtualTour() {
      this.$emit('virtualtour');
    },
    onVideo() {
      this.$emit('video');
    },
  },
});
